// App.js
import React from 'react';
import AppRoutes from './Routing/AppRoutes';

const App = () => {
  return (
    <div>
      <AppRoutes />
    </div>
  );
};

export default App;
